"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    theme: _propTypes.string.isRequired,
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    currencyCode: _propTypes.string.isRequired,
    priorityBaggageData: (0, _propTypes.shape)({
      departFlight: (0, _propTypes.shape)({
        id: _propTypes.string.isRequired,
        name: _propTypes.string,
        amount: _propTypes.number
      }).isRequired,
      returnFlight: (0, _propTypes.shape)({
        id: _propTypes.string.isRequired,
        name: _propTypes.string,
        amount: _propTypes.number
      })
    }).isRequired,
    selectedPriorityBaggage: _propTypes.object.isRequired,
    onSelectPriorityBaggage: _propTypes.func.isRequired
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: false,
    isMobile: false,
    currencyCode: '',
    priorityBaggageData: null,
    selectedPriorityBaggage: {},
    onSelectPriorityBaggage: function onSelectPriorityBaggage() {}
  }
};
exports.default = _default;